import { defineStore } from "pinia";

export const useTemplateStore = defineStore('template', {
    state: () => ({
        template: {},
        templates: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setTemplate(template) {
            this.template = template
        },
        setTemplates(templates) {
            this.templates = templates
        },
        addTemplate(template) {
            this.templates.unshift(template)
        },
        updateTemplate(template) {
            let index = this.templates.findIndex(cl => cl.id === template.id)
            this.templates.splice(index, 1, template)
        },
        deleteTemplate(template) {
            let index = this.templates.findIndex(cl => cl.id === template.id)
            this.templates.splice(index, 1)
        },
    },
});